<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="isProhibit" label="显示停产产品">
          <el-checkbox v-model="query.isProhibit" size="small" />
        </el-form-item>
        <el-form-item prop="fStockID" label="仓库">
          <el-select
            v-model="query.fStockID"
            style="width: 200px"
            size="small"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in stockList"
              :key="item.fStockID"
              :value="item.fStockID"
              :label="item.fName"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="fNumber" label="产品编号">
          <el-input v-model="query.fNumber" size="small" />
        </el-form-item>
        <el-form-item prop="fName" label="产品名称">
          <el-input v-model="query.fName" size="small" />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fNumber" label="产品编号" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="beginQty" label="上月库存" />
        <el-table-column prop="syQty" label="本月损益" />
        <el-table-column prop="thInQty" label="退货入库" />
        <el-table-column prop="inQty" label="本月入库" />
        <el-table-column prop="outQty" label="本月出库" />
        <el-table-column prop="fQty" label="现有库存" />
        <el-table-column prop="fStock" label="所属仓库" />
      </el-table>
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    ConfirmButton
  },
  data() {
    return {
      query: {
        isProhibit: null,
        fStockID: null,
        fNumber: null,
        fName: null
      },

      stockList: [],
      ICItemList: [],
      tableData: [],
      loading: false,
      currentEditItem: null,
      candown: true
    }
  },
  mounted() {
    this.refresh()
    this.getStockEntry()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006003002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/InventoryReport', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist
        })
        .finally(() => (this.loading = false))
    },
    getStockEntry() {
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.stockList = res.datalist
      })
    },

    downloadUrl: function() {
      const req = this.query

      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/InventoryReportDownload',
        { ...req }
      )
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
